module.exports = __webpack_public_path__ + "static/img/1054_big.1be99f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1054_big.png
// module id = UeSC
// module chunks = 1